import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

const PREVIEW_STORAGE_PREFIX = 'oms_shop_preview:'

export function readStoredPreviewToken(slug: string): string | null {
  try {
    return sessionStorage.getItem(`${PREVIEW_STORAGE_PREFIX}${slug}`)
  } catch {
    return null
  }
}

export function storePreviewToken(slug: string, token: string | null): void {
  const key = `${PREVIEW_STORAGE_PREFIX}${slug}`
  try {
    if (token) sessionStorage.setItem(key, token)
    else sessionStorage.removeItem(key)
  } catch {
    // ignore
  }
}

/** Preview token from ?preview= query (persisted per shop for in-site navigation). */
export function useShopPreviewToken(slug: string | undefined): string | null {
  const [searchParams] = useSearchParams()
  return useMemo(() => {
    if (!slug) return null
    const fromUrl = searchParams.get('preview')?.trim()
    if (fromUrl) {
      storePreviewToken(slug, fromUrl)
      return fromUrl
    }
    return readStoredPreviewToken(slug)
  }, [slug, searchParams])
}

export function appendPreviewQuery(url: string, previewToken: string | null): string {
  if (!previewToken) return url
  const sep = url.includes('?') ? '&' : '?'
  return `${url}${sep}preview=${encodeURIComponent(previewToken)}`
}
